'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$147(ps$85) {
  this.a6S = null;
  this.a6S = ps$85;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$147 as $c_Lmealorama_jsonCodecs$package$$anon$147 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$147.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$147;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$147() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$147 as $h_Lmealorama_jsonCodecs$package$$anon$147 };
$h_Lmealorama_jsonCodecs$package$$anon$147.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6S.a.length;
});
$p.g = (function(i) {
  return this.a6S.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$147 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$147, "mealorama.jsonCodecs$package$$anon$147", ({
  IY: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$147 as $d_Lmealorama_jsonCodecs$package$$anon$147 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$147.js.map
